import { SCALE_CONFIGS } from './constants';
import { buildGradient, resolveSelectedKey, toRgba } from './utils';

import type { ColorSenseBarProps } from './types';

export const ColorSenseBar = ({ analysis$ }: ColorSenseBarProps) => {
    return (
        <div className="w-full py-5 flex flex-col gap-6">
            {SCALE_CONFIGS.map(config => {
                const selectedKey = resolveSelectedKey(analysis$?.[config.metric], config);
                const lastPointIndex = config.points.length - 1;

                return (
                    <section key={config.metric}>
                        <h3 className="text-[16px] md:text-[18px] font-bold tracking-tight text-black">{config.title}</h3>

                        <div className="relative mt-3">
                            <div
                                className="absolute top-1/2 -translate-y-1/2 h-[5px] md:h-[6px] rounded-full z-0 left-1.5 right-1.5 md:left-2 md:right-2"
                                style={{
                                    background: buildGradient(config.points),
                                }}
                            />

                            <div className="relative z-10 flex items-center justify-between">
                                {config.points.map(point => {
                                    const isSelected = point.key === selectedKey;

                                    return (
                                        <div
                                            key={point.key}
                                            className="relative z-20 flex h-7 md:h-8 items-center justify-center"
                                        >
                                            {isSelected ? (
                                                <span className="relative inline-block rounded-full w-6 h-6 md:w-8 md:h-8">
                                                    <span className="absolute inset-0 rounded-full bg-[#efefef]" />
                                                    <span
                                                        className="absolute inset-0 rounded-full border-[3px] md:border-[5px]"
                                                        style={{
                                                            borderColor: point.color,
                                                            backgroundColor: toRgba(point.color, 0.35),
                                                        }}
                                                    />
                                                </span>
                                            ) : (
                                                <span
                                                    className="inline-block rounded-full w-3 h-3 md:w-4 md:h-4"
                                                    style={{
                                                        backgroundColor: point.color,
                                                    }}
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        <div className="mt-3 flex">
                            {config.points.map((point, index) => {
                                const isFirst = index === 0;
                                const isLast = index === lastPointIndex;

                                return (
                                    <div
                                        key={`${config.metric}-${point.key}`}
                                        className={`flex-1 leading-tight ${
                                            isFirst ? 'text-left' : isLast ? 'text-right' : 'text-center'
                                        }`}
                                    >
                                        <div className="h-5 md:h-6 text-[14px] md:text-[15px] font-medium text-black/55">
                                            {point.label ?? ''}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </section>
                );
            })}
        </div>
    );
};
